import axios from "axios";

const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

/**
 * Sends one product image to the backend.
 * Backend calls Gemini to generate 3 product images, uploads them to S3,
 * and returns an array of 3 public S3 URLs.
 */
export async function generateProductImages(file) {
  const form = new FormData();
  form.append("file", file);

  const res = await API.post("/api/ai/product-images", form, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120000, // image generation can take up to ~2 min
  });

  // res.data = { status: true, data: ["https://...", "https://...", "https://..."] }
  return res.data.data;
}
